import "@tamagui/polyfill-dev";
import { setupReactNative } from "@tamagui/core";
import * as React from "react";
import { Text, View } from "react-native";
globalThis.React = React;
setupReactNative({
  View,
  Text
});
typeof requestAnimationFrame > "u" && (globalThis.requestAnimationFrame = setImmediate);
const cancelAnimationFrame = globalThis.cancelAnimationFrame;
typeof globalThis > "u" ? console.warn(
  "Warning: globalThis is undefined, are you overwriting it in your bundler?"
) : globalThis.cancelAnimationFrame = (x) => {
  try {
    cancelAnimationFrame(x);
  } catch {
  }
};
const idFn = () => {
};
export {
  idFn
};
